const PublisherModuleDetail = {
    title: 'Game On-boarding',
    nav: [
        {
            name: 'Publishing Pipeline Setup',
            url: 'jenkins-resign-pipeline',
            groupsAllowed: [],
        },
        {
            name: 'Firebase Crashlytics',
            url: 'firebase-crashlytics',
            groupsAllowed: [],
        },
    ],
    loadModule: () => import('./bigfishgames-game-on-boarding-portal-module.module-91cc5b10.mjs').then((m) => m.PortalModule),
};

/*
 * Public API Surface of hello-module
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PublisherModuleDetail };
